export default {
  name: 'peacock-supplier-center', //系统别称，用于系统辨别
  version: '23000', //系统版本
  asideCollapse: false, //侧边栏默认配置
  menuCollapse: false, //菜单是否进行收缩
  pageTransition: true, //是否默认开启页面切换动画
  tabCache: false, //页面是否缓存
  isAuthorize: true //是否检验权限
}
